import React from "react";
import { useNavigate } from "react-router-dom";
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import DiamondOutlinedIcon from '@mui/icons-material/DiamondOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import StarIcon from '@mui/icons-material/Star';
import VerifiedIcon from '@mui/icons-material/Verified';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import TrendingDownIcon from '@mui/icons-material/TrendingDown';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckIcon from '@mui/icons-material/Check';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Tab, Tabs, Avatar, Typography, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell, PieChart, Pie } from 'recharts';

const engagementData = [
    { name: '', likes: 12000, reviews: 8000, messages: 15000, follows: 10000 },
    { name: 'Likes/Saves', likes: 25000, reviews: 10000, messages: 12000, follows: 8000 },
    { name: '', likes: 15000, reviews: 12000, messages: 18000, follows: 9000 },
    { name: 'Reviews', likes: 18000, reviews: 15000, messages: 14000, follows: 11000 },
    { name: '', likes: 22000, reviews: 14000, messages: 16000, follows: 9500 },
    { name: 'Messages', likes: 14000, reviews: 11000, messages: 13000, follows: 8500 },
    { name: '', likes: 16000, reviews: 13000, messages: 17000, follows: 10500 },
    { name: 'Follows', likes: 28000, reviews: 16000, messages: 15000, follows: 12000 },
];

const interactionData = [
    { name: 'Fashion', value: 38, color: '#8b5cf6' },
    { name: 'All Other Categories', value: 22, color: '#10b981' },
    { name: 'Handramade & Artisan', value: 13, color: '#f59e0b' },
    { name: 'Beauty', value: 19, color: '#06b6d4' },
    { name: 'Home Services', value: 17, color: '#ec4899' },
];

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}
const BouteekCommunity = () => {
    const navigate = useNavigate();
    const [valueTabs, setValueTabs] = React.useState(0);
    const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
        setValueTabs(newValue);
    };
    return (
        <>
            <div className="main_title">
                <h1> Bouteek Community</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -  Bouteek Community
                </p>
            </div>
            <div className="stats_boxes gap_m">
                {/* Total Members */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            246K
                            <p>Total Members</p>
                        </h2>
                        <figure className="blue">
                            <GroupsOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p className="blue" style={{ fontSize: '13px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span style={{ fontWeight: '700' }}>1.27K</span>
                            <span style={{ fontSize: '11px', color: '#717171' }}>Total community members</span>
                        </p>
                    </div>
                </div>

                {/* Engagement Rate */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            72.8%
                            <p>Engagement Rate</p>
                        </h2>
                        <figure className="sucess">
                            <ForumOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p className="green" style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <span style={{ fontWeight: '700' }}>72.8%</span>
                            <span style={{ fontSize: '11px', color: '#717171' }}>Engagement Rate</span>
                            <ArrowUpwardIcon sx={{ fontSize: 14 }} />
                        </p>
                    </div>
                </div>

                {/* Interactions */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            192K
                            <p>Interactions</p>
                        </h2>
                        <figure className="blue">
                            <AutorenewOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="rating_box">
                        <p style={{ fontSize: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <DiamondOutlinedIcon sx={{ fontSize: 16, color: '#f59e0b' }} />
                            <span style={{ fontWeight: '700' }}>10%</span>
                            <span style={{ fontSize: '11px', color: '#717171' }}>Increase from last 30 days</span>
                        </p>
                    </div>
                </div>

                {/* Repeat Interaction Rate */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            48%
                            <p>Repeat Interaction Rate</p>
                        </h2>
                        <figure className="warning">
                            <AutorenewOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                </div>
            </div>
            <div className="engagement_overview_container cards mt_20">
                <div className="ov_title_header">
                    <h3>Engagement Overview</h3>
                   
                </div>

                <div className="ov_content_grid">
                    {/* Left: Engagement Bar Chart */}
                    <div className="ov_chart_box lt">
                        <div className="chart_header_v5">
                            <div className="c_title">
                                <AutorenewOutlinedIcon sx={{ fontSize: 16, color: '#717171' }} />
                                <span>Engagement</span>
                                <small>30 Days</small>
                            </div>
                        </div>

                        <div className="chart_wrap_v5">
                            <ResponsiveContainer width="100%" height={260}>
                                <BarChart data={engagementData} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f0f0f0" />
                                    <XAxis
                                        dataKey="name"
                                        axisLine={false}
                                        tickLine={false}
                                        tick={{ fill: '#9ca3af', fontSize: 12 }}
                                        interval={1}
                                    />
                                    <YAxis
                                        axisLine={false}
                                        tickLine={false}
                                        tick={{ fill: '#9ca3af', fontSize: 12 }}
                                        tickFormatter={(value) => `${value / 1000}K`}
                                    />
                                    <Tooltip cursor={{ fill: 'transparent' }} />
                                    <Bar dataKey="follows" stackId="a" fill="#10b981" barSize={35} radius={[0, 0, 0, 0]} />
                                    <Bar dataKey="messages" stackId="a" fill="#8b5cf6" barSize={35} />
                                    <Bar dataKey="reviews" stackId="a" fill="#f59e0b" barSize={35} />
                                    <Bar dataKey="likes" stackId="a" fill="#3b82f6" barSize={35} radius={[6, 6, 0, 0]} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>

                        <div className="custom_legend_v5">
                            <div className="leg_item"><span className="dot" style={{ background: '#3b82f6' }}></span> Likes/Saves</div>
                            <div className="leg_item"><span className="dot" style={{ background: '#f59e0b' }}></span> Reviews</div>
                            <div className="leg_item"><span className="dot" style={{ background: '#8b5cf6' }}></span> Messages</div>
                            <div className="leg_item"><span className="dot" style={{ background: '#10b981' }}></span> Follows</div>
                        </div>
                    </div>

                    {/* Right: Top Interactions Donut Chart */}
                    <div className="ov_chart_box rt">
                        <div className="chart_header_v5">
                            <div className="c_title">
                                <span>Top Interactions</span>
                                <KeyboardArrowRightIcon sx={{ fontSize: 18, color: '#717171' }} />
                            </div>
                            <Button size="small" variant="text" sx={{ textTransform: 'none', color: '#9ca3af', fontSize: '11px' }}>All DRESST</Button>
                        </div>

                        <div className="donut_grid_v5">
                            <div className="donut_wrap">
                                <ResponsiveContainer width="100%" height={220}>
                                    <PieChart>
                                        <Pie
                                            data={interactionData}
                                            innerRadius={55}
                                            outerRadius={85}
                                            paddingAngle={3}
                                            dataKey="value"
                                            stroke="none"
                                        >
                                            {interactionData.map((entry, index) => (
                                                <Cell key={`cell-${index}`} fill={entry.color} />
                                            ))}
                                        </Pie>
                                        <Tooltip />
                                    </PieChart>
                                </ResponsiveContainer>
                                <div className="donut_center">
                                    {/* Optional text in middle */}
                                </div>
                            </div>

                            <div className="donut_legend">
                                {interactionData.map((item, idx) => (
                                    <div className="d_leg_item" key={idx}>
                                        <span className="dot" style={{ background: item.color }}></span>
                                        <div className="l_text">
                                            <p>{item.name}</p>
                                        </div>
                                    </div>
                                ))}
                                <div className="d_leg_filter">
                                    <span className="dot" style={{ background: '#3b82f6' }}></span>
                                    <span>Other categories</span>
                                    <KeyboardArrowRightIcon sx={{ fontSize: 14, transform: 'rotate(90deg)' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="table_flex mt_20">
                <div className="lt">
                    <div className="leaderboards_grid">
                        {/* Most Engaged Customers */}
                        <div className="leaderboard_card cards">
                            <div className="card_header">
                                <h3>Most Engaged Customers</h3>
                                <button className="see_all">See All</button>
                            </div>
                            <div className="list_items">
                                {[
                                    { name: "Miriam Al Zaheri", points: "514", growth: "1.27K", avatar: "M" },
                                    { name: "Nasir Al Qassim", points: "933", growth: "2.5K", avatar: "N" },
                                    { name: "Amal Bellamy", points: "684", growth: "3.1K", avatar: "A" },
                                    { name: "Hassan Al Ameri", points: "553", growth: "1.2K", avatar: "H" },
                                    { name: "Shaheen Yousif", points: "556", growth: "1.8K", avatar: "S" },
                                ].map((item, i) => (
                                    <div className="item_row" key={i}>
                                        <div className="item_left">
                                            <Avatar sx={{ bgcolor: i % 2 === 0 ? '#6366f1' : '#10b981', width: 35, height: 35, fontSize: '14px' }}>{item.avatar}</Avatar>
                                            <div className="info">
                                                <Typography variant="body2" className="name">{item.name}</Typography>
                                                <Typography variant="caption" className="sub">Points: {item.growth}</Typography>
                                            </div>
                                        </div>
                                        <div className="item_right">
                                            <Typography variant="body2" sx={{ fontWeight: 700 }}>{item.points}</Typography>
                                            <div className="growth_badge green">
                                                <RocketLaunchIcon sx={{ fontSize: 12 }} />
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Top Community Vendors */}
                        <div className="leaderboard_card cards">
                            <div className="card_header">
                                <h3>Top Community Vendors</h3>
                                <button className="see_all">See All</button>
                            </div>
                            <div className="list_items">
                                {[
                                    { name: "Crafty Casa", rating: 4.8, customers: "6,001+", logo: "C" },
                                    { name: "Fashion Hub", rating: 4.9, customers: "12,300+", logo: "F" },
                                    { name: "Luxe Electronics", rating: 4.7, customers: "8,900+", logo: "L" },
                                    { name: "Premium Seller", rating: 5.0, customers: "3,200+", logo: "P" },
                                    { name: "FastClean Pros", rating: 4.6, customers: "2,001+", logo: "F" },
                                ].map((item, i) => (
                                    <div className="item_row" key={i}>
                                        <div className="item_left">
                                            <Avatar sx={{ bgcolor: '#f59e0b', width: 35, height: 35, fontSize: '14px' }}>{item.logo}</Avatar>
                                            <div className="info">
                                                <Typography variant="body2" className="name">{item.name}</Typography>
                                                <Typography variant="caption" className="sub">{item.customers} Customers</Typography>
                                            </div>
                                        </div>
                                        <div className="item_right" style={{ textAlign: 'right' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '2px', color: '#f59e0b' }}>
                                                <StarIcon sx={{ fontSize: 14 }} />
                                                <Typography variant="body2" sx={{ fontWeight: 700 }}>{item.rating}</Typography>
                                            </div>
                                            <VerifiedIcon sx={{ fontSize: 14, color: '#3b82f6' }} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Top Service Providers */}
                        <div className="leaderboard_card cards">
                            <div className="card_header">
                                <h3>Top Service Providers</h3>
                            </div>
                            <div className="list_items">
                                {[
                                    { name: "FastClean Pros", jobs: "600+", rating: "4.8", status: "Active" },
                                    { name: "StyleScape Design", jobs: "411+", rating: "4.9", status: "Active" },
                                    { name: "Blossom Beauty", jobs: "650+", rating: "4.7", status: "Active" },
                                    { name: "HandyFix UAE", jobs: "840+", rating: "5.0", status: "Active" },
                                ].map((item, i) => (
                                    <div className="item_row" key={i}>
                                        <div className="info_full">
                                            <div className="title_row">
                                                <Typography variant="body2" className="name">{item.name}</Typography>
                                                <div className="meta">
                                                    <StarIcon sx={{ fontSize: 14, color: '#f59e0b' }} />
                                                    <Typography variant="caption">{item.rating}</Typography>
                                                </div>
                                            </div>
                                            <div className="action_row">
                                                <Typography variant="caption" sx={{ color: '#717171' }}>{item.jobs} Completed Projects</Typography>

                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    <div className="cards mt_20">
                        <div className="card_header" style={{ marginBottom: '20px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <h3 style={{ fontSize: '18px', fontWeight: '800' }}>Cross-Community Intelligence</h3>
                            </div>
                        </div>

                        <div className="table_header_v3" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <GroupsOutlinedIcon sx={{ color: '#10b981' }} />
                                <Typography variant="subtitle1" sx={{ fontWeight: '700' }}>Top Community Interactions</Typography>
                            </div>
                        
                        </div>

                        <TableContainer className="table_container_v3">
                            <Table sx={{ minWidth: 650 }}>
                                <TableHead sx={{ bgcolor: '#f9fafb' }}>
                                    <TableRow>
                                        <TableCell sx={{ color: '#717171', fontWeight: '600' }}>Customers</TableCell>
                                        <TableCell sx={{ color: '#717171', fontWeight: '600' }}>Top Rated Sellers</TableCell>
                                        <TableCell sx={{ color: '#717171', fontWeight: '600' }}>Trending</TableCell>
                                        <TableCell sx={{ color: '#717171', fontWeight: '600' }}>Rankings</TableCell>
                                        <TableCell sx={{ color: '#717171', fontWeight: '600' }}>Trend Categories</TableCell>
                                        <TableCell sx={{ color: '#717171', fontWeight: '600' }}>Avg. Ratings</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {[
                                        {
                                            cat: "Champions",
                                            icon: "🏆",
                                            badge: <VerifiedIcon sx={{ fontSize: 12, color: '#10b981' }} />,
                                            sellers: [40, 60, 80, 50, 30],
                                            stars: 4,
                                            score: "3.4",
                                            rank: "97%",
                                            trend: "+45.75%",
                                            subTrend: "1.24k",
                                            avg: "889",
                                            avgSub: "4.9",
                                            color: "#3b82f6"
                                        },
                                        {
                                            cat: "Influencers",
                                            icon: "�",
                                            badge: <ForumOutlinedIcon sx={{ fontSize: 12, color: '#3b82f6' }} />,
                                            sellers: [80, 40, 60, 70, 90],
                                            stars: 4,
                                            score: "3.6",
                                            rank: "97%",
                                            trend: "-15.55%",
                                            subTrend: "2.3",
                                            avg: "699",
                                            avgSub: "4.9",
                                            color: "#10b981"
                                        },
                                        {
                                            cat: "Regulers",
                                            icon: "🔄",
                                            badge: <AutorenewOutlinedIcon sx={{ fontSize: 12, color: '#ef4444' }} />,
                                            sellers: [50, 70, 40, 60, 30],
                                            stars: 4,
                                            score: "3.5",
                                            rank: "87%",
                                            trend: "+05.36%",
                                            subTrend: "3220",
                                            avg: "829",
                                            avgSub: "5.5",
                                            color: "#84cc16"
                                        },
                                        {
                                            cat: "Regulers",
                                            icon: "�",
                                            badge: <GroupsOutlinedIcon sx={{ fontSize: 12, color: '#3b82f6' }} />,
                                            sellers: [30, 50, 70, 40, 60],
                                            stars: 4,
                                            score: "3.6",
                                            rank: "67%",
                                            trend: "+15.90%",
                                            subTrend: "3.74",
                                            avg: "929",
                                            avgSub: "5.5",
                                            color: "#f59e0b"
                                        }
                                    ].map((row, i) => (
                                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <Avatar sx={{ width: 32, height: 32, bgcolor: '#f3f4f6', color: '#000', fontSize: '14px' }}>{row.icon}</Avatar>
                                                    <Typography variant="body2" sx={{ fontWeight: '700' }}>{row.cat}</Typography>
                                                    {row.badge}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', gap: '4px', alignItems: 'flex-end', height: '30px' }}>
                                                    {row.sellers.map((h, j) => (
                                                        <Box key={j} sx={{ width: '12px', height: `${h}%`, bgcolor: row.color, opacity: 0.3 + (j * 0.15), borderRadius: '2px' }} />
                                                    ))}
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                                                    <div style={{ display: 'flex', color: '#f59e0b' }}>
                                                        <StarIcon sx={{ fontSize: 14 }} />
                                                        <StarIcon sx={{ fontSize: 14 }} />
                                                        <StarIcon sx={{ fontSize: 14 }} />
                                                        <StarIcon sx={{ fontSize: 14 }} />
                                                    </div>
                                                    <Typography variant="caption" sx={{ fontWeight: '700' }}>{row.score}</Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                    <VerifiedIcon sx={{ fontSize: 16, color: '#10b981' }} />
                                                    <Typography variant="body2" sx={{ fontWeight: '700' }}>{row.rank}</Typography>
                                                    <Box sx={{ bgcolor: '#f3f4f6', p: 0.5, borderRadius: '4px' }}>
                                                        <DiamondOutlinedIcon sx={{ fontSize: 12, color: '#9ca3af' }} />
                                                    </Box>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <Typography variant="body2" sx={{ fontWeight: '700', color: row.trend.startsWith('+') ? '#10b981' : '#ef4444' }}>
                                                        {row.trend.startsWith('+') ? '▲' : '▼'} {row.trend}
                                                    </Typography>
                                                    <Typography variant="caption" sx={{ color: '#f59e0b', fontWeight: '600' }}>
                                                        {row.subTrend}
                                                    </Typography>
                                                </div>
                                            </TableCell>
                                            <TableCell>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <Typography variant="body2" sx={{ fontWeight: '700' }}>{row.avg}</Typography>
                                                    <Typography variant="caption" sx={{ color: '#10b981', fontWeight: '700' }}>{row.avgSub}</Typography>
                                                    <Box sx={{ width: '40px', height: '4px', bgcolor: '#f3f4f6', borderRadius: '2px', position: 'relative' }}>
                                                        <Box sx={{ position: 'absolute', left: 0, top: 0, height: '100%', width: i % 2 === 0 ? '70%' : '40%', bgcolor: i % 2 === 0 ? '#10b981' : '#f59e0b', borderRadius: '2px' }} />
                                                    </Box>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    <div className="cards mt_20">
                        <div className="card_header">
                            <h3 style={{ fontSize: '18px', fontWeight: '800' }}>Cross-Community Intelligence</h3>
                       
                        </div>

                        <div className="interaction_map_section">
                            {/* Intensity Grid Section */}
                            <div className="intensity_grid_section">
                                <div className="table_header_v3" style={{ marginBottom: '15px' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <GroupsOutlinedIcon sx={{ color: '#10b981' }} />
                                        <Typography variant="subtitle1" sx={{ fontWeight: '700' }}>Top Community Interactions</Typography>
                                    </div>
                                </div>

                                <div className="tabs_v4">
                                    <div className="chip_v4 active">Top Rated Sellers</div>
                                    <div className="chip_v4">Frencing voviders</div>
                                    <div className="chip_v4">Laaed Providers</div>
                                </div>

                                <div className="intensity_map">
                                    {[
                                        { label: "Champions", group: "group_blue" },
                                        { label: "Influneres", group: "group_blue" },
                                        { label: "Regulers", group: "group_blue" },
                                        { label: "Regulers", group: "group_blue" },
                                    ].map((row, idx) => (
                                        <div className="intensity_row" key={idx}>
                                            <div className="row_label">{row.label}</div>
                                            <div className={`blocks_group ${row.group}`}>
                                                <div className="block v1"></div>
                                                <div className="block v2"></div>
                                                <div className="block v3"></div>
                                                <div className="block v4"></div>
                                            </div>
                                            <div className="blocks_group group_green">
                                                <div className="block v1"></div>
                                                <div className="block v2 has_icon">🛡️</div>
                                                <div className="block v3"></div>
                                                <div className="block v4"></div>
                                            </div>
                                            <div className="blocks_group group_yellow">
                                                <div className="block v1 has_icon">✨</div>
                                                <div className="block v2"></div>
                                                <div className="block v3 has_text">+10%</div>
                                                <div className="block v4 has_text">300%</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="legend_v4">
                                    <div className="legend_item">
                                        <div className="dot" style={{ background: '#3b82f6' }}></div>
                                        Aesia Funtacted
                                    </div>
                                    <div className="legend_item">
                                        <div className="dot" style={{ background: '#10b981' }}></div>
                                        Aersage
                                    </div>
                                    <div className="legend_item">
                                        <div className="dot" style={{ background: '#f59e0b', opacity: 0.4 }}></div>
                                        Report Customers
                                    </div>
                                </div>
                            </div>

                            {/* Relationship Network Section */}

                        </div>

                        <div className="ai_recommendations_bar">
                            <div className="ai_rec_heading">
                                <AutoAwesomeIcon />
                                <h4>AI Recommendations</h4>
                            </div>

                            <div className="ai_rec_content">
                                <div className="ai_rec_pill">
                                    <span className="pct">+ 52%</span>
                                    <span className="lbl">surface</span>
                                </div>
                                <div className="ai_rec_pill">
                                    <span className="pct">+ 37%</span>
                                    <span className="lbl">explore</span>
                                </div>
                                <div className="ai_rec_pill">
                                    <span className="pct">+ 54%</span>
                                    <span className="lbl">relations</span>
                                </div>
                                <div className="ai_rec_pill">
                                    <span className="pct">+ 41%</span>
                                    <span className="lbl">reviews</span>
                                </div>
                                <div className="ai_rec_pill large">
                                    <span className="title">Section Profit</span>
                                    <span className="sub">AI customers</span>
                                </div>
                                <div className="ai_rec_pill large">
                                    <span className="title">Lead Details</span>
                                    <span className="sub">performance</span>
                                </div>
                            </div>

                            <div className="ai_rec_action">
                                <CheckIcon />
                                <AutoAwesomeIcon sx={{ fontSize: 14, ml: 0.5 }} />
                            </div>
                        </div>
                    </div>
                </div>

                <div className="rt">
                    <div className="ai_panel">
                        <h4>AI Insights</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                    <div className="ai_panel mt_20">
                        <h4>AI Recommendations</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                </div>

            </div>

        </>
    )
};
export default BouteekCommunity;